import script from "./SubAspectDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SubAspectDetail.vue?vue&type=script&setup=true&lang=js"

import "./SubAspectDetail.vue?vue&type=style&index=0&id=4bd2696f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd2696f"]])

export default __exports__